module.exports = __webpack_public_path__ + "static/media/ventixal_logo.d9079f3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ventixal_logo.png
// module id = 1365
// module chunks = 0